export const manuale = {
  apri: 'Apri il manuale',
  dialog: {
    titolo: 'Manuale',
    chiudi: 'Chiudi il manuale',
    indice: 'Sezioni del manuale',
    scorciatoia: 'Scorciatoia: premi ? da qualsiasi pagina per aprire il manuale sulla sezione giusta.',
  },
};
